










































































































































import { PaginatedList } from "@/api/models/common/paginatedList";
import { Partenaire } from "@/api/models/partenaires/partenaire";
import {
  BButton,
  BCard,
  BCol,
  BDropdown,
  BFormSelect,
  BFormCheckbox,
  BDropdownItem,
  BFormInput,
  BPagination,
  BRow,
  BTable,
  BAlert,
} from "bootstrap-vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import CreatePartenaire from "./Create.vue";

@Component({
  components: {
    BAlert,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    BFormCheckbox,
    BTable,
    BPagination,
    BDropdown,
    BDropdownItem,
    BFormSelect,
    CreatePartenaire,
  },
})
export default class ListPartenaires extends Vue {
  perPage = 10;
  currentPage = 1;
  perPageOptions = [2, 5, 10, 25, 50, 100];
  timeout: any = null;
  searchQuery = "";
  pertinentOnly = false;
  isSortDirDesc = false;
  sortBy = "nom";
  isAddNewPartenaireSidebarActive = false;

  tableColumns = [
    { key: "nom", sortable: true },
    { key: "ville", sortable: true },
    { key: "telephone1", sortable: true },
    { key: "telephone2", sortable: true },
    { key: "pertinentLabel", sortable: true, label : "Pertinent" }
  ];
  paginatedListPartenaires = new PaginatedList<Partenaire>();

  async created() {
    await this.loadListPartenaires({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      pertinentOnly: this.pertinentOnly
    });
  }

  get paginationFrom() {
    return (
      this.perPage * (this.currentPage - 1) +
      (this.paginatedListPartenaires.items.length ? 1 : 0)
    );
  }
  get paginationTo() {
    return (
      this.perPage * (this.currentPage - 1) +
      this.paginatedListPartenaires.items.length
    );
  }

  @Watch("currentPage")
  @Watch("perPage")
  @Watch("pertinentOnly")
  async paginationChanged() {
    await this.loadListPartenaires({
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      search: this.searchQuery,
      pertinentOnly: this.pertinentOnly
    });
  }

  @Watch('searchQuery')
  @Watch("sortBy")
  @Watch("isSortDirDesc")
  @Watch("pertinentOnly")
  async searchPartenaire() {
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListPartenaires({
        pageNumber: this.currentPage,
        pageSize: this.perPage,
        orderBy: this.sortBy,
        orderByDescending: this.isSortDirDesc,
        search: this.searchQuery,
        pertinentOnly: this.pertinentOnly,
      })
    }, 1200);
  }

  updateSort(params: any) {
    this.sortBy = params.sortBy;
    params = {
      pageNumber: this.currentPage,
      pageSize: this.perPage,
      orderBy: this.sortBy,
      orderByDescending: this.isSortDirDesc,
      pertinentOnly: this.pertinentOnly
    };
    this.isSortDirDesc = !this.isSortDirDesc;

    this.loadListPartenaires(params);
  }

  async loadListPartenaires(params: any) {
    console.log(params);
    if (!params || params?.reset) {
      this.paginatedListPartenaires = new PaginatedList<Partenaire>();
    }
    await this.$http.myressif.partenaires
      .paginatedList(
        params?.pageNumber ?? 1,
        params?.pageSize ?? 10,
        params?.orderBy,
        params?.orderByDescending,
        params?.search ?? "",
        params?.pertinentOnly,
      )
      .then((response: PaginatedList<Partenaire>) => {
        this.paginatedListPartenaires = response;
      });
  }

  onRowSelected(record: any) {
    this.$router.push({
      name: "details-partenaires",
      params: { id: record.id },
    });
  }
}
